<template>
  <Modal class="dea-modal-add-school dea-modal--no-footer" :visible="visible" @modalClose="modalClose()">
    <template slot="title">
      <template v-if="savedSchool">
        Hai appena aggiunto questa scuola:
      </template>
      <template v-else>
        La tua scuola
      </template>
    </template>
    <template slot="content">
      <div class="dea-modal-add-school__content">
        <template v-if="savedSchool">
          <div class="dea-modal-add-school__selected dea-bg-grey-light">
            <SchoolData
              :name="selectedSchool.name"
              :label="getGrade(selectedSchool.degree_id)"
              :address="createAddress(selectedSchool)"
              :show-edit-link="true"
            />
            <div class="dea-school-selection__cta-container">
              <Links
                href="#"
                class-name="dea-links dea-links--target-color-blue-docenti dea-links--large"
                @click="goBack"
              >
                Modifica
              </Links>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="user.principal" class="dea-modal-add-school__leading-school">
            <div class="dea-modal-add-school__leading-school-title dea-heading--medium-m">
              Sei responsabile della gestione di una scuola Polo?
            </div>
            <div class="dea-modal-add-school__leading-school-radio">
              <RadioButton
                id="leading-school-yes"
                :checked="isLeadingSchool"
                name="leading-school"
                value="yes"
                @click="switchLeading"
                >Si</RadioButton
              >
              <RadioButton
                id="leading-school-no"
                :checked="!isLeadingSchool"
                name="leading-school"
                value="no"
                @click="switchLeading"
                >No</RadioButton
              >
            </div>
          </div>
          <div class="dea-modal-add-school__search">
            <div class="dea-modal-add-school__search-city">
              <div class="dea-modal-add-school__search-city-title dea-heading--medium-m">
                In quale comune si trova la scuola in cui insegni?
              </div>
              <InputText
                v-model="selectedCity"
                class="dea-modal-add-school__search-city-input dea-input--margin-responsive"
                placeholder="Cerca comune"
                :add-reset-button="true"
                icon="ricerca"
                :icon-left="true"
                @keyup="getCityList()"
                @reset="resetCitiesList()"
              />
              <CitiesList
                v-if="citiesList.length && selectedCity"
                :cities-list="citiesList"
                :query="selectedCity"
                @city-selected="citySelected"
              />
            </div>
            <div class="dea-modal-add-school__search-grade">
              <div class="dea-modal-add-school__search-grade-title dea-heading--medium-m">
                Scegli il grado scolastico
              </div>
              <InputSelect
                name="gradeList"
                :disabled="!Boolean(URLParams.city)"
                placeholder="Scegli grado scolastico"
                @change="setGrade($event)"
              >
                <option
                  v-for="(option, idx) in $root.asyncConf.degrees_json"
                  :key="idx"
                  :selected="parseInt(optionSelected, 10) === option.id"
                  :value="option.id"
                  >{{ option.name }}</option
                >
              </InputSelect>
            </div>
          </div>
          <div v-if="URLParams.degree_id" class="dea-modal-add-school__results">
            <div class="dea-modal-add-school__results-title dea-heading--medium-m">
              Abbiamo trovato {{ schoolsNumber }} scuole. In quale insegni?
            </div>
            <div class="dea-modal-add-school__results-description dea-heading--medium-s">
              Seleziona la tua scuola dall'elenco o filtra le scuole usando il nome dell'istituto, l'indirizzo della
              sede principale o il codice meccanografico.
            </div>
            <InputText
              v-model="filterSchool"
              class="dea-modal-add-school__results-filter dea-input--margin-responsive"
              placeholder="Filtra per nome Scuola, Indirizzo, Codice Meccanografico"
              icon="ricerca"
              :icon-left="true"
              @keyup="getSchoolsList()"
            />
            <div class="dea-modal-add-school__results-link">
              <Links
                :href="$root.config.support_url"
                class-name="dea-links dea-links--target-color-blue-docenti dea-links--large"
                target="_blank"
              >
                La tua scuola non è in elenco? Contattaci
              </Links>
            </div>
            <div class="dea-modal-add-school__results-list">
              <SchoolRadio
                v-for="(school, idx) in schoolsList"
                :id="`${school.id}`"
                :key="idx"
                :address="createAddress(school)"
                check-name="school-radio"
                check-type="radio"
                :checked="selectedSchool && school.id === selectedSchool.id"
                :code="`(${school.miur_code})`"
                :label="getGrade(school.degree_id)"
                :name="school.name"
                :value="JSON.stringify(school)"
                @change="selectSchool"
              />
            </div>
            <div class="dea-modal-add-school__results-pagination">
              <PaginationBlock :pagination="pagination" @changePage="changePage" />
            </div>
            <div class="dea-modal-add-school__results-save-button">
              <Buttons class="dea-button--large" :disabled="!selectedSchool" @click="saveSelected">Salva</Buttons>
            </div>
          </div>
        </template>
      </div>
    </template>
  </Modal>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions } from "vuex";
import Buttons from "@/components/elements/Buttons";
import InputSelect from "@/components/elements/InputSelect";
import InputText from "@/components/elements/InputText";
import Links from "@/components/elements/Links";
import PaginationBlock from "@/components/elements/PaginationBlock";
import RadioButton from "@/components/elements/RadioButton";
import SchoolData from "@/components/elements/SchoolData";
import Modal from "@/components/patterns/Modal";
import SchoolRadio from "@/components/patterns/SchoolRadio";
import CitiesList from "./CitiesList";
import Schools from "../../../clients/schools";

export default {
  name: "AddSchoolModal",
  components: {
    Buttons,
    CitiesList,
    InputSelect,
    InputText,
    Links,
    Modal,
    PaginationBlock,
    RadioButton,
    SchoolRadio,
    SchoolData,
  },
  props: {
    schoolGrade: {
      type: Number,
      default: null,
    },
    schoolToModify: {
      type: Object,
      default: null,
    },
    user: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      citiesList: [],
      filterSchool: "",
      isLeadingSchool: false,
      modifySchool: null,
      pagination: {},
      savedSchool: null,
      schoolsList: [],
      schoolsNumber: 0,
      selectedCity: "",
      selectedSchool: null,
      URLParams: {
        city: "",
        degree_id: "",
      },
    };
  },
  computed: {
    optionSelected() {
      if (this.modifySchool) {
        return this.modifySchool.degree_id;
      }
      if (this.schoolGrade) {
        return this.schoolGrade;
      }
      return -1;
    },
  },
  mounted() {
    if (this.schoolToModify) {
      this.modifySchool = { ...this.schoolToModify };
      this.isLeadingSchool = this.modifySchool.polo;
      this.selectedCity = this.modifySchool.city;
      this.URLParams.city = this.modifySchool.city;
      this.URLParams.degree_id = this.modifySchool.degree_id;
      this.getSchoolsList();
    }
  },
  methods: {
    ...mapActions(["fetchUser"]),
    changePage(page) {
      let pagination = page;
      if (page === "prev" && this.pagination.has_previous) {
        pagination = this.pagination.current - 1;
      } else if (page === "next" && this.pagination.has_next) {
        pagination = this.pagination.current + 1;
      } else if (page === "first" && this.pagination.has_previous) {
        pagination = 1;
      } else if (page === "last" && this.pagination.has_next) {
        pagination = this.pagination.last;
      }

      this.getSchoolsList(pagination);
    },
    citySelected(city) {
      this.URLParams.city = city;
      this.selectedCity = city;
      this.resetCitiesList();
      if (this.schoolGrade) {
        this.URLParams.degree_id = `${this.schoolGrade}`;
        this.getSchoolsList();
      } else if (this.URLParams.degree_id) {
        this.getSchoolsList();
      }
    },
    createAddress(school) {
      return `${school.address} - ${school.zip_code} ${school.city} (${school.area_id})`;
    },
    async getCityList() {
      if (this.selectedCity.length > 1) {
        const params = { ...this.$root.config.getCityParams };
        params.city = `${this.selectedCity}`;
        params.year = `${this.$root.asyncConf.current_teachers_year}`;

        try {
          const results = await Schools.getSchools(this.$root.config, params);
          this.citiesList = results.data;
        } catch (e) {
          Sentry.captureException(e);
        }
      }
    },
    getGrade(id) {
      const gradeName = this.$root.asyncConf.degrees_json.filter(grade => grade.id === parseInt(id, 10));
      return gradeName[0].name;
    },
    async getSchoolsList(page) {
      const params = { ...this.$root.config.getSchoolsParams };
      params.city = `${this.URLParams.city}`;
      params.degree_id = `${this.URLParams.degree_id}`;
      params.year = `${this.$root.asyncConf.current_teachers_year}`;

      if (this.filterSchool) {
        params.q = this.filterSchool;
      }
      if (page) {
        params.page = page;
      }

      try {
        const response = await Schools.getSchools(this.$root.config, params);
        this.setPagination(response.headers);
        this.schoolsList = response.data;
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    goBack() {
      this.modifySchool = { ...this.selectedSchool };
      this.selectedSchool = null;
      this.savedSchool = null;
      this.pagination = {};
      this.schoolsList = [];
      this.getSchoolsList();
    },
    modalClose() {
      this.selectedCity = "";
      this.URLParams.city = "";
      this.URLParams.degree_id = "";
      this.selectedSchool = null;
      this.savedSchool = null;
      this.modifySchool = null;
      this.resetCitiesList();
      this.$emit("close-modal");
    },
    async removeSchool(school) {
      try {
        await Schools.deleteSchool(this.$root.config, school, this.user.id);
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    resetCitiesList() {
      this.citiesList = [];
    },
    async saveSchool(school) {
      const body = {
        polo: this.isLeadingSchool,
        school_id: school.id,
        user_id: this.user.id,
        year: school.year,
      };

      try {
        await Schools.saveSchool(this.$root.config, body);
        await Schools.getUpdateAgencies(this.$root.config);
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    async saveSelected() {
      document.querySelector("body").classList.add("wait");
      if (this.modifySchool) {
        await this.removeSchool(this.modifySchool);
      }
      await this.saveSchool(this.selectedSchool);
      await this.fetchUser(true);
      document.querySelector("body").classList.remove("wait");
      this.savedSchool = this.selectedSchool;
      setTimeout(() => {
        this.modalClose();
      }, 2000);
    },
    setGrade(evt) {
      if (evt.target.value) {
        this.URLParams.degree_id = evt.target.value;
        this.getSchoolsList();
      }
    },
    setPagination(headers) {
      const productsCount = headers["x-total"];
      const limit = headers["x-limit"];
      const current = parseInt(headers["x-page"], 10);
      const pages = Math.ceil(Number(productsCount) / limit);
      const first = Math.max(current - 3, 1);
      const last = Math.min(first + 3, pages);
      this.pagination = {
        show_first: pages > 1,
        show_last: pages > 1,
        has_previous: current !== 1 && pages > 1,
        has_next: current !== pages && pages > 1,
        pages: [],
        current,
        last: pages,
      };
      // eslint-disable-next-line no-plusplus
      for (let i = first; i <= last; i++) {
        this.pagination.pages.push({
          number: i,
          clickable: i !== this.pagination.current,
        });
      }
      this.schoolsNumber = productsCount;
    },
    selectSchool(evt) {
      this.selectedSchool = JSON.parse(evt.target.value);
    },
    switchLeading(e) {
      this.isLeadingSchool = e.target.value === "yes";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$modal-selected-min-width: 800px;

.dea-modal-add-school {
  &__content {
    display: flex;
    flex-direction: column;
  }

  &__leading-school {
    margin-bottom: $space-small;

    &-radio {
      margin: $space-base 0;
    }
  }

  &__search {
    @include media("<=l") {
      flex-direction: column;
    }

    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &-city {
      @include media("<=l") {
        margin-bottom: $space-base;
        margin-right: 0;
      }

      flex-grow: 1;
      margin-right: $space-large;

      &-title {
        margin-bottom: $space-small;
      }

      &-input {
        @include media("<=l") {
          .dea-input__wrapper {
            min-width: 100%;
          }
        }

        margin-bottom: 0 !important; //sass-lint:disable-line no-important
        width: 100% !important; //sass-lint:disable-line no-important
      }
    }
  }

  &__results {
    margin-top: $space-base;

    &-title,
    &-description {
      margin-bottom: $space-small;
    }

    &-link {
      display: flex;
      flex-direction: row-reverse;
      margin-bottom: $space-small;
    }

    &-filter {
      width: 100% !important; //sass-lint:disable-line no-important

      .dea-input__wrapper {
        @include media("<=l") {
          min-width: 100%;
        }

        input {
          background-color: $dea-color-grey-light;
        }
      }
    }

    &-list {
      max-height: 300px;
      overflow-y: auto;
    }

    &-pagination {
      margin: $space-base 0;
    }

    &-save-button {
      display: flex;
      flex-direction: row-reverse;
    }
  }

  &__selected {
    @include media("<=l") {
      flex-direction: column;
      min-width: unset;
    }

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 (-$space-large) $space-xx-large (-$space-large);
    min-width: $modal-selected-min-width;
    padding: $space-x-large $space-large $space-xm-small $space-large;
  }
}
</style>
